export default __webpack_public_path__ + "static/media/img2.912c172a.png";